var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseError',{staticClass:"max-w-lg mx-auto mt-16 text-base",attrs:{"errors":_vm.errors}})}
var staticRenderFns = []

export { render, staticRenderFns }